
import React, { useCallback, useEffect } from 'react'
import PropTypes from 'prop-types'
import { goToSummary } from 'utils/navigate'
import { StepList } from 'components/stepper'
import FlowModal from './FlowModal'
import { useDispatch } from 'react-redux'
import { resetModalMetadata } from '@/features/ui/ui-slice'

function FlowStepList(props) {
  const dispatch = useDispatch()

  const onStepNavigation = useCallback(() => {
    dispatch(resetModalMetadata())
  }, [dispatch])

  useEffect(() => {
    return () => {
      onStepNavigation()
    }
  }, [onStepNavigation])

  const { 
    onClose = goToSummary, 
    layout = FlowModal, 
    children, 
    hideNavBar,
    ...restProps 
  } = props
  // If hideNavBar is true, don't render the FlowModal wrapper
  const finalLayout = hideNavBar ? null : layout

  return (
    <StepList
      {...props}
      onClose={onClose}
      layout={finalLayout}
      {...restProps}
      onStepNavigation={onStepNavigation}
    >
      {children}
    </StepList>
  )
}

FlowStepList.propTypes = {
  onClose: PropTypes.func,
  layout: PropTypes.func,
  children: PropTypes.any,
  hideNavBar: PropTypes.bool,
  modalOverrideCss: PropTypes.object,
  navBarOverrideCss: PropTypes.object,
}

export default FlowStepList
